import React from "react";
import { tw } from "twind";

import SatelliteMenuButton from "composants/satellite/SatelliteMenuButton";
import { ComponentState } from "types/Component";
import { Fa } from "composants/Icon";

export function SateliteMenuRenderer({
  sjmoCode,
  ctrlkey,
  currentFilter,
  columns,
  existSatellite,
}: {
  sjmoCode: string;
  ctrlkey: string;
  currentFilter?: string;
  columns: ComponentState[];
  existSatellite: Record<string, boolean>;
}) {
  return (props: any) => {
    if (props.data && props.data.id && props.data.tableName) {
      const existSatelliteData =
        (existSatellite && props.data && existSatellite[props.data.id]) || false;

      return (
        <SatelliteMenuButton
          isActive={props.data.id && props.data.id.split("~").length < 4 ? true : false}
          sjmoCode={sjmoCode}
          tableName={props.data.tableName}
          entityId={props.data.id}
          ctrlKey={ctrlkey}
          filter={currentFilter}
          columns={columns.slice(0, 4).map((col) => col.column)}
          className={tw(
            `bg-transparent border-0 align-baseline p-0 ${
              existSatelliteData ? "text-blue-500" : "text-gray-500 hover:text-black"
            }`,
          )}
          style={{
            height: 25,
          }}
        >
          <Fa icon={[existSatelliteData ? "fad" : "far", "satellite"]} />
        </SatelliteMenuButton>
      );
    } else {
      return <div />;
    }
  };
}

